<template>
   <div class="progress" v-if="this.active">
      <ProgressSpinner class="size" animationDuration="3" strokeWidth="2" aria-label="Carregando" />
   </div>
</template>
<script src="./progress.js"></script>
